import './WelcomeStyle.less';

import * as React from 'react';

import { IBrokerageInfo } from '@opendoor/bricks';

interface IProps {
  acqCxLeadImageUrl: string;
  acqCxLeadPhoneNumber: string;
  acqCxLeadFullName: string;
  brokerageInfo: IBrokerageInfo;
  leadFirstName: string;
}

export default (props: IProps) => {
  const {
    acqCxLeadFullName,
    acqCxLeadImageUrl,
    acqCxLeadPhoneNumber,
    brokerageInfo,
    leadFirstName,
  } = props;
  const welcomeTitle = `Hi ${leadFirstName}, your offer is ready!`;
  const welcomeText = `
    I'm ${acqCxLeadFullName}, an agent with ${
    brokerageInfo.name
  }, Opendoor's affiliated real estate brokerage. I'm
    here to answer any questions you have and guide you through your offer - feel free to reach out to me directly
    anytime. I'm looking forward to working with you.
  `;
  return (
    <section className="route-offer-welcome">
      <div className="regular-container">
        <div className="box padded od-offer-welcome-box">
          <div className="prose text-center">
            <h1 className="offer-title">{welcomeTitle}</h1>
            <p className="welcome-text">{welcomeText}</p>
            <img className="img-circle cx-lead-image" src={acqCxLeadImageUrl} />
            <p>
              {acqCxLeadFullName}
              <br />
              REALTOR
              <br />
              <a href="mailto:transactions@opendoor.com">transactions@opendoor.com</a>
              <br />
              {acqCxLeadPhoneNumber}
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};
